import React from 'react';
import { connect } from 'react-redux';

import { AddressFormFieldName, ConnectedAddressForm } from 'shared/components/AddressForm/AddressForm';
import { IValidationInputData, ValidationInput } from 'shared/components/ValidationInput';

import { Button } from 'shared/components/Button';
import { ISlimCreateRetailerFormStore, SlimCreateRetailerFormActions, SlimCreateRetailerFormActionInterfaces } from 'shared/components/SignUpOrSignIn/SlimCreateRetailerForm/actions';
import { ISlimCreateRetailerFormState, SlimCreateRetailerFormFieldName } from 'shared/components/SignUpOrSignIn/SlimCreateRetailerForm/reducers';
import { BevSpotDispatch } from 'shared/components/Provider';

export interface ISlimCreateRetailerFormProps {
    slimCreateRetailerFormState : ISlimCreateRetailerFormState;
    onSubmit : (retailerName : string, addressForm : {[fieldName in AddressFormFieldName] : IValidationInputData }) => Promise<void>;
}

export interface IBoundSlimCreateRetailerFormProps extends ISlimCreateRetailerFormProps {
    dispatch : BevSpotDispatch<ISlimCreateRetailerFormStore, { services: SlimCreateRetailerFormActionInterfaces.IServices }>;
}

export class SlimCreateRetailerForm extends React.Component<IBoundSlimCreateRetailerFormProps, object> {

    public render() {
        const {
            slimCreateRetailerFormState,
        } = this.props;

        return (
            <div className="sign-up-form">
                <div className="row">
                    <div className="col-xs-12">
                        { this.makeValidationInput('retailerName', slimCreateRetailerFormState.validationInputDataByFieldName.retailerName, `Bar Name`) }
                    </div>
                </div>
                <div className="row">
                    <ConnectedAddressForm // for right now, need full address to create a retailer
                        validationInputDataByFieldName={ slimCreateRetailerFormState.validationInputDataByFieldName }
                        rowClassName="col-xs-12"
                        addressLine1Label="Street Address Line 1"
                        addressLine2Label="Street Address Line 2 (Optional)"
                        zipCodeAndCountryAreDisabled={ false }
                        setValidationInputForField={ this.setAddressFormField }
                        onEnterClick={ this.doNothing }
                    />
                </div>
                <Button
                    buttonClassName="modal-sign-up-button primary"
                    isDisabled={ slimCreateRetailerFormState.isSubmitting }
                    isLoading={ slimCreateRetailerFormState.isSubmitting }
                    onClick={ this.onSubmitFormClick }
                >
                    JOIN BEVSPOT
                </Button>
                { !slimCreateRetailerFormState.isValid && slimCreateRetailerFormState.errorMessage &&
                    <p className="form-error-message">{ slimCreateRetailerFormState.errorMessage }</p>
                }
            </div>
        );
    }

    private readonly doNothing = () => undefined;

    private readonly onFormFieldChange = (field : SlimCreateRetailerFormFieldName, value : string | boolean) => {
        return this.props.dispatch(SlimCreateRetailerFormActions.onFormFieldChange(field, value));
    }

    private readonly onFormFieldBlur = (field : SlimCreateRetailerFormFieldName, value : string | boolean) => {
        return this.props.dispatch(SlimCreateRetailerFormActions.onFormFieldBlur(field, value));
    }

    private readonly setAddressFormField = (fieldName : AddressFormFieldName, validationInputData : IValidationInputData) => {
        return this.props.dispatch(SlimCreateRetailerFormActions.onSetAddressFormField(fieldName, validationInputData));
    }

    private readonly onSubmitFormClick = () => {
        const {
            dispatch,
            slimCreateRetailerFormState,
            onSubmit
        } = this.props;

        return dispatch(SlimCreateRetailerFormActions.onSubmit(slimCreateRetailerFormState))
        .then((isValid : boolean) => {
            if (isValid) {
                onSubmit(slimCreateRetailerFormState.validationInputDataByFieldName.retailerName.value, slimCreateRetailerFormState.validationInputDataByFieldName);
            }
        });
    }

    private readonly makeValidationInput = (fieldName : SlimCreateRetailerFormFieldName, fieldData : IValidationInputData, label : string) : JSX.Element => {
        const onChange = (event : React.ChangeEvent<HTMLInputElement>) => this.onFormFieldChange(fieldName, event.currentTarget.value);
        const onBlur = (event : React.FocusEvent<HTMLInputElement>) => this.onFormFieldBlur(fieldName, event.currentTarget.value);

        return (
            <ValidationInput
                key={ fieldName }
                inputClassName=""
                type="text"
                autoFocus={ false }
                autoComplete={ null }
                errorMessage={ fieldData.errorMessage }
                isValid={ fieldData.isValid }
                handleBlur={ onBlur }
                handleFocus={ null }
                handleChange={ onChange }
                handleEnterClick={ this.doNothing }
                label={ label }
                hintText={ null }
                value={ fieldData.value }
            />
        );
    }
}

export interface IConnectedSlimCreateRetailerFormProps {
    onSubmit : (retailerName : string, addressForm : {[fieldName in AddressFormFieldName] : IValidationInputData }) => Promise<void>;
}

interface IState {
    slimCreateRetailerFormState : ISlimCreateRetailerFormState;
}
const mapStateToProps = (state : IState, ownProps : IConnectedSlimCreateRetailerFormProps) : ISlimCreateRetailerFormProps => {
    return {
        slimCreateRetailerFormState : state.slimCreateRetailerFormState,
        onSubmit : ownProps.onSubmit,
    };
};

export const ConnectedSlimCreateRetailerForm = connect<ISlimCreateRetailerFormProps, object, IConnectedSlimCreateRetailerFormProps, IState>(mapStateToProps)(SlimCreateRetailerForm);
